import React from "react";
import { motion } from "framer-motion";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosuretaskscss from "../../myfin_v2/css/bookclosuretasks.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import ImageCarousel from "../../myfin_v2/components/ImageCarousel";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";

const UploadMethod = (props) => {
  const screen = {
    width: "100%",
    height: "100%",
    position: "fixed",
    zIndex: "999",
    backgroundColor: "#00000099",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  };
  const container = {
    // minHeight:'60vh',
    borderRadius: "10px",
    maxHeight: "90vh",
    minWidth: "560px",
    padding: "2rem 3rem",
    zIndex: "15",
    backgroundColor: "white",
  };

  const head = {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "3rem",
  };

  const header = {
    fontSize: "2.2rem",
    fontWeight: "700",
  };
  const center = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const card = {
    borderRadius: "6px",
    border: "2px solid lightGrey",
    width: "13rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "8rem",
    padding: "2rem",
    cursor: "pointer",
  };

  function handleSelectMethod(txt) {
    props.setUploadMethod(false);
    props.setViewFormat(true);
    props.setMethod(txt);
  }

  return (
    <>
      <Modal
        title="Upload Trial Balance (Excel)"
        bodycss={commoncss.unsetPadding}
        width="45%"
        headerActions={
          <></>
          // <CloseIcon
          //   onClick={() => { props.setViewFormat(false) }}
          //   className="clickable"
          // />
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div className={commoncss.pd1530}>
          <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`} style={{ placeContent: "center" }}>
            <div
              class={`${commoncss.pdlr15}  ${commoncss.m_tb_20}`}
            >
              <div
                className={`${bookclosurecss.addMutiFormantCardST} ${commoncss.clickable}`}

                onClick={() => {
                  handleSelectMethod("MultiFile");
                }}
              >
                <div className={bookclosurecss.addTBCardContent}>
                  <span className={`${bookclosurecss.addTBCardLabel} ${commoncss.fs15}`}>
                    Upload as  <br /> multiple excel files
                  </span>
                  {/* <span className={`${bookclosurecss.addTBCardDescription}  ${commoncss.fs13}`}>
                    Upload excel file.
                  </span> */}
                </div>
              </div>
            </div>
            <div
              class={`${commoncss.pdlr15} ${commoncss.m_tb_20} `}
            >
              <div
                className={bookclosurecss.addMutiFormantCardST}
                onClick={() => {
                  handleSelectMethod("MultiSheet");
                }}
              >
                <div className={bookclosurecss.addTBCardContent}>
                  <span className={`${bookclosurecss.addTBCardLabel} ${commoncss.fs15}`}>
                    Upload as <br />
                    multiple excel sheets
                  </span>
                </div>
              </div>
            </div>
          </div>

          <span className={`${commoncss.headerInfo} ${commoncss.fs13}`}>
            Make sure only one sheet is present if one file is uploaded at a
            time
          </span>

        </div>
      </Modal>
      <motion.div
        style={screen}
        className="screenDiv"
        // onClick={handleClose}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        hidden
      >
        {/* <div style={{display:'flex',flexDirection:'column'}}> */}
        <motion.div
          style={container}
          className="col-md-4 col-sm-6"
          initial={{ y: "-5vh" }}
          animate={{ y: 0 }}
        >
          <div style={center}>
            <h3 style={header}>Choose One</h3>
          </div>
          <div style={head}>
            <div
              style={card}
              onClick={() => {
                handleSelectMethod("MultiFile");
              }}
            >
              <p style={{ textAlign: "center" }}>
                Upload as Multiple excel files
              </p>
            </div>
            <div
              style={card}
              onClick={() => {
                handleSelectMethod("MultiSheet");
              }}
            >
              <p style={{ textAlign: "center" }}>
                Upload as Multiple excel Sheets
              </p>
            </div>
          </div>
          <div style={{ display: "flex", padding: "0 1rem" }}>
            <p
              style={{
                fontSize: "15px",
                fontWeight: "400",
                color: "var(--clr-accent)",
                textAlign: "center",
              }}
            >
              {" "}
              <i
                class="fas fa-info-circle"
                style={{ color: "var(--clr-accent)" }}
              ></i>{" "}
              Make sure only one sheet is present if one file is uploaded at a
              time
            </p>
          </div>
        </motion.div>
        {/* </div> */}
      </motion.div>
    </>
  );
};

export default UploadMethod;
